import React from 'react';
import { Grid, ListItem, ListItemText, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { ReactComponent as PlaceRoundIcon } from 'src/assets/images/PlaceRound.svg';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: '0.5rem 0 0',
    },
    name: {
        color: theme.palette.primary.main,
        fontSize: '1.25rem',
        textTransform: 'uppercase',
    },
}));

type NameProps = {
    name: string;
    location: string;
}

export const Name = ({ name, location }: NameProps) => {
    const classes = useStyles();
    const theme = useTheme();

    return (
        <ListItem alignItems="flex-start" className={classes.container}>
            <ListItemText
                primary={<Typography variant="h3" className={classes.name}>{name}</Typography>}
                secondary={(
                    <Grid container spacing={1}>
                        <Grid item>
                            <PlaceRoundIcon height="12" width="16" fill={theme.palette.tertiary.main} />
                        </Grid>
                        <Grid item>
                            <Typography color="primary" variant="body2">{location}</Typography>
                        </Grid>
                    </Grid>
                )}
                disableTypography
            />
        </ListItem>
    );
};
